import React from 'react';
import { NavLink } from "react-router-dom";

const NavActivites = (props) => {
  return (
  
    <nav id="menu" className="navactivites navactivites-default navactivites-fixed">
      <div className="container">
        <div className="navactivites-header">
          <button
            type="button"
            className="navactivites-button-toggle collapsed "
            data-toggle="collapse"
            data-target="#bs-example-navactivites-collapse-1"
          >
          <h4> Mes activités ☰</h4>
          </button>
          
        </div>

        <div
          className="collapse navactivites-collapse"
          id="bs-example-navactivites-collapse-1"
        >
         <ul className="nav navbar-nav navactivites-right">
            <li>
              <NavLink to="/athletisme" className="activites">
            Athlétisme
              </NavLink>
            </li>
            <li>
              <NavLink to="/cross_training" className="activites">
                Cross training  
              </NavLink></li>
            <li>
              <NavLink to="/fitdance" className="activites">
                Fitdance
              </NavLink>
            </li>
            <li>
              <NavLink to="/pilates" className="activites">
                Pilates
              </NavLink>
            </li>
            <li>
              <NavLink to="/cardio_boxing" className="activites">
                Cardio boxing
              </NavLink>
            </li>
          </ul>

        </div>
      </div>
    </nav>
  );
};
export default NavActivites;